import { Button } from "@/components/ui/button";
import { BookingFlowHeaderProps } from "./booking-flow-header.types";
import { ChevronLeftIcon } from "lucide-react";

export const BookingFlowHeader = ({
  onClick,
  title,
  subtitle,
}: BookingFlowHeaderProps) => {
  return (
    <div className="justify-items-start items-start gap-4 inline-flex mt-8 w-full flex">
      <Button
        onClick={onClick}
        className="bg-white border border-gray-200 text-black p-2 pr-2 rounded-md text-sm px-3 hover:bg-gray-900 group"
      >
        <ChevronLeftIcon className="w-4 h-4 text-black group-hover:text-white transition-colors duration-200" />
      </Button>
      <div className="flex-col justify-start items-start inline-flex">
        <div className="text-bg-black text-lg font-medium leading-7">
          {title}
        </div>
        <div className="text-zinc-500 text-sm font-normal leading-tight">
          {subtitle}
        </div>
      </div>
    </div>
  );
};
